import React from 'react';
import InsightList from '../components/InsightList';
import { PRODUCTIVITY_READ_THROUGH, SYMPTOMS } from '../copy';
import { fmtPct, rankByPrevalence } from '../format';

/**
 * What each deficiency means for the person who has it, and what that adds up to for the organisation.
 * Prevalence is data; the symptom lists are clinical copy.
 */
const SymptomImpact = ({ data }) => {
  const ranked = rankByPrevalence(data.markers).filter((marker) => SYMPTOMS[marker.key]);

  return (
    <div className='mt-ds-9'>
      <h3 className='m-0 mb-[6px] font-fig-extrabold text-[28px] font-bold leading-[1.18] text-gray-900'>
        Health impact &amp; symptoms
      </h3>
      <p className='m-0 mb-[22px] text-ts-md text-gray-600'>
        What each deficiency means for the employee experiencing it
      </p>

      <div className='grid grid-cols-1 gap-ds-4 sm:grid-cols-2 lg:grid-cols-4'>
        {ranked.map((marker) => (
          <div
            key={marker.key}
            className='rounded-ds-lg border border-gray-300 border-t-[3px] border-t-ds-amber bg-white p-ds-6'
          >
            <div className='text-ts-md font-semibold text-gray-900'>{marker.label}</div>
            <div className='mt-ds-2 font-jetbrains-mono text-[26px] font-semibold tabular-nums text-ds-amber-dk'>
              {fmtPct(marker.prevalence)}
            </div>
            <div className='mt-ds-4 border-t border-gray-300 pt-ds-4 text-[14px] leading-[1.65] text-gray-700'>
              {SYMPTOMS[marker.key]}
            </div>
          </div>
        ))}
      </div>

      <div className='mt-ds-4 rounded-ds-lg border border-gray-300 bg-white px-[32px] py-[30px]'>
        <div className='mb-ds-5 text-ts-xs font-semibold uppercase tracking-[0.12em] text-ds-brand'>
          Productivity read-through
        </div>
        <InsightList
          columns={2}
          items={PRODUCTIVITY_READ_THROUGH.map((entry, index) => (
            <React.Fragment key={index}>
              {entry.lead ? (
                <strong className='font-semibold text-gray-900'>{entry.lead}</strong>
              ) : null}
              {entry.rest}
            </React.Fragment>
          ))}
        />
      </div>
    </div>
  );
};

export default SymptomImpact;
